"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
exports.sandwichIds = {
    applyForARefund: {
        balanceEncouragement: {
            directDebitExplanation: 'payments-balanceRefundDDExplanation-image',
            splitExplanation: 'payments-balanceRefundSplitExplanation-image',
            refundExplanation: 'payments-balanceRefundExplanation-image',
        },
    },
    setupRegularPayment: {
        status: {
            success: 'payments-setup-regular-payment-success-image',
            mandateError: 'payments-setup-regular-payment-mandateError-image',
            scheduleError: 'payments-setup-regular-payment-scheduleError-image',
        },
    },
};
